import { Insurer } from '@getvim-os/standard';

export const insurer: Insurer = Insurer.FLORIDA_BLUE;
